import { call, put, takeLatest } from 'redux-saga/effects';
import { saveEmail } from '../../services/API';

import { actionTypes, requestFailure, requestSuccess } from './actions';

function* sendData(action) {
  const response = yield call(saveEmail, action.payload);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* saveEmailSaga() {
  yield takeLatest(actionTypes.START_REQUEST, sendData);
}
